export default __webpack_public_path__ + "static/media/comment-purple.15d66fab.svg";